// These constants are used in multiple projects with different deployment lifecycles.
// For migration, it requires simultaneous v1 and v2 support and a feature flag for which one to use.
export const NAVIGATE = 'NAVIGATE';
export const LOGOUT = 'LOGOUT';
export const LOAN_ID_CHANGE = 'LOAN_ID_CHANGE';
export const USE_PRODUCTS_SYNC = 'USE_PRODUCTS_SYNC';
export const WEB_LOGIN_COMPONENT_MOUNTED = 'WEB_LOGIN_COMPONENT_MOUNTED';
export const WEB_LOGIN_NEW_USER_PRODUCTS = 'WEB_LOGIN_NEW_USER_PRODUCTS';
export const WEB_SHARE_NATIVE = 'WEB_SHARE_NATIVE';
export const WEB_NAVBAR_PCL_HELP = 'WEB_NAVBAR_PCL_HELP';
export const AUTH_SESSION_CHANGED = 'AUTH_SESSION_CHANGED';
export const AUTH_CREDENTIALS_SUBMIT = 'AUTH_CREDENTIALS_SUBMIT';
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_ERROR = 'AUTH_LOGIN_ERROR';
export const ADJUST_TRACK_EVENT = 'ADJUST_TRACK_EVENT';
export const APP_RATE_RUN_CONDITION_CREDIT_HEALTH = 'APP_RATE_RUN_CONDITION_CREDIT_HEALTH';
export const MOBILE_START_PAYMENT_FLOW = 'MOBILE_START_PAYMENT_FLOW';
//# sourceMappingURL=web-view.js.map